import { createReducer, on } from '@ngrx/store';
import * as fromDirectDebitAttempts from '../actions/direct.debit.attempts.action';
import { StateSlice } from '@core/helpers/state-slice';

export interface DirectDebitAttempts {
  attempts: number;
}

export type DirectDebitAttemptsState = StateSlice<DirectDebitAttempts>;

export const initialState: DirectDebitAttemptsState = {
  data: { attempts: 0 },
  loaded: false,
  loading: false,
  error: null,
};

const directDebitAttemptsReducer = createReducer(
  initialState,
  on(fromDirectDebitAttempts.addDirectDebitAttempt, (state) => ({
    data: {
      attempts: state.data.attempts + 1,
    },
    loading: false,
    loaded: true,
    error: null,
  })),
  on(fromDirectDebitAttempts.resetDirectDebitAttempts, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: DirectDebitAttemptsState | undefined,
  action: fromDirectDebitAttempts.DirectDebitAttemptActions
) {
  return directDebitAttemptsReducer(state, action);
}
